import React from 'react';

import Button        from '@material-ui/core/Button';
import Dialog        from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle   from '@material-ui/core/DialogTitle';
import TextField     from '@material-ui/core/TextField';

export default function NewText(props) {
  return (
    <Dialog fullWidth open={props.rowid > -1}>
      <DialogTitle>
        {props.title}
      </DialogTitle>
      <DialogContent>
        <TextField fullWidth
          multiline={props.multiline || false}
          onChange={props.onChange}
          rows={props.rows || 1}
          value={props.value}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onCancel}>
          {'취소'}
        </Button>
        <Button color="primary" onClick={props.onSubmit}>
          {'확인'}
        </Button>
      </DialogActions>
    </Dialog>
  );
}